import { Col, Menu, Row } from "antd";
import { forwardRef, useEffect, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import Server from "../../server/Server";
import URL from "../../server/URL";
import Error404 from "../error/Error404";
import AutoCode from "./bizParams/autocode/AutoCode";
import ParamConfig from "./ParamConfig";

const ParamSetting = forwardRef((props: any, ref: any) => {
    const [bu, setBU] = useState<any>(null);
    const [items, setItems] = useState<any['items']>([])
    const [openKeys, setOpenKeys] = useState<any>([]);
    const [selectKeys, setSelectKeys] = useState<any>(["0"]);
    const [curentPage, setCurrentPage] = useState<any>([]);

    useEffect(() => {
        loadData()
    }, [bu, props.scope, props.activeKey])

    const loadData = () => {
        var request = {
            scope: props.scope
        }
        Server.Post(URL.BizParamSetting.GetBizParamSettingList, request).then((response: any) => {
            if (response.isSuccess) {
                var data: any[] = [];
                var rootKeys: any = [];
                (response.data ?? []).map((item: any, index: any) => {
                    var node: any = generateData(item);
                    data.push(node);
                    rootKeys.push(node.key);
                })
                data.splice(0, 0, {
                    key: '0',
                    label: <Link to={'/system/paramSetting?scope=' + (props.scope??0)}>配置类参数</Link>,
                });
                setItems(data);
                setOpenKeys(rootKeys)
                setSelectKeys(["0"]);
                setCurrentPage('配置类参数');
            }
        });
    }

    const generateData = (item: any) => {
        var label = item.name;
        if (item.bizParamTypeEnum == 1 && item.router && item.router != '') {
            label = <Link to={item.router}>{item.name}</Link>
        }
        var node: any = {
            key: item.bizParamSettingID,
            label: label,
            icon: item.icon,
        };
        if (item.children && item.children.length > 0) {
            node.children = [];
            (item.children ?? []).map((child: any, index: any) => {
                var childNode = generateData(child);
                node.children.push(childNode);
            })
        }
        return node;
    }

    useEffect(() => {
        if (selectKeys) {
            items.map((item: any) => {
                if (item.key == selectKeys[0]) {
                    setCurrentPage(item.label?.props?.children ?? '');
                } else {
                    var filters = (item.children ?? []).filter((i: any) => i.key == selectKeys[0]);
                    if (filters && filters.length > 0) {
                        setCurrentPage(filters[0].label.props.children);
                    }
                }
            })

        }
    }, [selectKeys]);
    return (
        <div style={{ height: '100%' }}>
            <div style={{ height: 'calc(100vh - 75px)' }}>
                <Row style={{ height: '100%' }}>
                    <Col span={4} style={{ border: '1px solid #d9d9d9', height: '100%' }}>
                        <div style={{ backgroundColor: '#fafafa', borderBottom: '1px solid #e7e7eb', padding: '5px' }}>
                            <span style={{ lineHeight: '26px', margin: '5px', fontWeight: 'bold' }}>业务参数</span>
                        </div>
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={[selectKeys]}
                            defaultOpenKeys={openKeys}
                            openKeys={openKeys}
                            selectedKeys={selectKeys}
                            onOpenChange={(value) => {
                                setOpenKeys(value);
                            }}
                            onSelect={(e) => {
                                setSelectKeys(e.selectedKeys);
                            }}
                            style={{
                                height: 'calc(100% - 40px)',
                                overflowY: 'auto'
                            }}
                            items={items}
                        />
                    </Col>
                    <Col span={20} style={{ border: '1px solid #d9d9d9', borderLeft: 'none', height: '100%' }}>
                        <div style={{ backgroundColor: '#fafafa', borderBottom: '1px solid #e7e7eb', padding: '5px' }}>
                            <span style={{ lineHeight: '26px', margin: '5px', fontWeight: 'bold' }}>{curentPage ?? ''}</span>
                        </div>
                        <div className="site-layout-background" style={{
                            height: 'calc(100% - 38px)',
                            overflowY: 'auto',
                            padding: '4px'
                        }}>
                            <Routes>
                                <Route path={'/'} element={<ParamConfig />} />
                                {/* oms */}
                                <Route path={'/autocode'} element={<AutoCode />} />
                                <Route path="*" element={<Error404 />} />
                            </Routes>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
});
export default ParamSetting;